import { FormattedMessage } from "react-intl";
import EmptyState from "../../../components/EmptyState";

export function NoQuickPostSearchResult() {
  return (
    <EmptyState section="search-quick-post">
      <h3>
        <FormattedMessage
          id="common.search.no_quick_post_results"
          defaultMessage="We couldn't find any matching Quick Post"
        />
      </h3>
      <p>
        <FormattedMessage
          id="common.search.no_results_description"
          defaultMessage="Try adjusting or using different search terms."
        />
      </p>
    </EmptyState>
  );
}
